module.exports = __webpack_public_path__ + "img/btn-more.2b438841.jpg";